import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { List, ListItem, Typography } from '@mui/material';
import clsx from 'clsx';
import { ONE_PAGE_STYLE_OPTIONS } from 'layouts/OnePagePreviewLayout/types';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlan } from 'store/useBusinessToolStore/selectors';

import { STATUS_VALUE_OPTIONS } from 'components/BusinessToolForm/constants/optionValues';
import { STYLE_VARIANTS } from 'components/OnePageTemplates/interfaces/variants';

import { IGanttChartLegendProps } from './types';

import styles from './GanttChartLegend.module.scss';

export const GanttChartLegend: FC<IGanttChartLegendProps> = ({ variant }) => {
  const businessPlan = useBusinessToolStore(getBusinessPlan);
  const { t } = useTranslation()
  const isOutlined = variant === STYLE_VARIANTS.OUTLINED;

  const onePageVariant = businessPlan.metadata.onePageTemplateStyle;

  const listItems = [
    { label: t('statuses.done'), className: styles.done },
    {
      label: t('statuses.inProgress') ,
      className: onePageVariant === ONE_PAGE_STYLE_OPTIONS.THIRD_STYLE ? styles.inProgress_third : styles.inProgress,
    },
    { label: t('statuses.toDo') , className: styles.toDo },
  ];

  return (
    <List className={styles.legendList}>
      {listItems.map(({ label, className }) => (
        <ListItem
          key={label}
          className={clsx(styles.legendItem, className, {
            [styles.outlined]: isOutlined && label === t('statuses.inProgress'),
          })}
        >
          <Typography variant="body1">{label}</Typography>
        </ListItem>
      ))}
    </List>
  );
};
